import { WorkflowResultContent } from "../workflowData/WorkflowResultContent";
import { ClientBrainProposalCard } from "../clientBrainActions/ClientBrainProposalCard";
import { useTranslation } from "react-i18next";
import type { PersonalRun } from "./models";
import styles from "./HomeWorkflows.module.css";

export function PersonalRunCard({ run }: { run: PersonalRun }) {
    const { t, i18n } = useTranslation();
    return (
        <article className={styles.card}>
            <h3>{run.title}</h3>
            <p>
                {t("homeWorkflow.private", { defaultValue: "Private workflow result" })}
                {run.project_name ? ` · ${run.project_name}` : ""}
            </p>
            <time dateTime={run.updated_at}>{new Date(run.updated_at).toLocaleString(i18n.language)}</time>
            {run.status !== "completed" && <p role="status">{run.error ?? t("homeWorkflow.running", { defaultValue: "Running workflow…" })}</p>}
            {run.preview?.boxes.map(box => {
                const definition = run.workflow.boxes.find(item => item.id === box.box_id);
                const option = definition?.options.find(item => item.value === box.selected_value);
                return (
                    <section key={box.box_id}>
                        <h4>{definition?.title ?? box.box_id}</h4>
                        {box.client_brain_proposal && <ClientBrainProposalCard proposal={box.client_brain_proposal} interactive />}
                        {option && <p>{option.label}</p>}
                        <WorkflowResultContent content={box.content} statistics={box.statistics} />
                        {box.source_references.map((source, index) => (
                            <details key={`${source.source_id}:${index}`}>
                                <summary>{source.source_label}</summary>
                                <p className={styles.content}>{source.source_excerpt}</p>
                            </details>
                        ))}
                        {box.evidence_spans.length > 0 && (
                            <details>
                                <summary>{t("homeWorkflow.evidence", { defaultValue: "From your input" })}</summary>
                                {box.evidence_spans.map((span, index) => (
                                    <p key={index}>{span}</p>
                                ))}
                            </details>
                        )}
                    </section>
                );
            })}
        </article>
    );
}
